import { render, staticRenderFns } from "./SettingsTheme.vue?vue&type=template&id=553d3a65"
import script from "./SettingsTheme.vue?vue&type=script&lang=js"
export * from "./SettingsTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports